import React from 'react';

export default function FormConfirmation() {
  return (
    <div className="form-public-wrapper">
      <div className="form-public-card fade-in" style={{ maxWidth: 480 }}>
        <div className="form-public-header text-center">
          <div style={{ fontSize: '3.5rem', lineHeight: 1 }}>✅</div>
          <h3 className="mt-3 mb-1 fw-bold">Réponses envoyées !</h3>
          <p className="mb-0 opacity-80" style={{ fontSize: '0.9rem' }}>Merci pour ta participation.</p>
        </div>
        <div className="form-public-body text-center text-muted">
          <p style={{ fontSize: '0.95rem' }}>
            Tes réponses ont bien été enregistrées.<br />
            Tu peux fermer cette page.
          </p>
        </div>
      </div>
    </div>
  );
}
